/** API / list-filter values for `tariff_dataset` and selector `catalogueScope`. */
export const TARIFF_DATASET_DEFAULT = 'default' as const
export const TARIFF_DATASET_ALL = 'all' as const
export const TARIFF_DATASET_MY_CUSTOM = 'my_custom_tariffs' as const
export const TARIFF_DATASET_OS_MANAGED = 'os_managed_tariffs' as const

export type TariffSelectorCatalogueScope =
  | typeof TARIFF_DATASET_DEFAULT
  | typeof TARIFF_DATASET_MY_CUSTOM
  | typeof TARIFF_DATASET_OS_MANAGED

export type TariffCatalogueListDatasetFilter =
  | typeof TARIFF_DATASET_ALL
  | typeof TARIFF_DATASET_MY_CUSTOM
  | typeof TARIFF_DATASET_OS_MANAGED

type TranslateFn = (key: string) => string

export function getTariffSelectorCatalogueScopeOptions(translate: TranslateFn) {
  return [
    { id: 'catalogue-default', value: TARIFF_DATASET_DEFAULT, title: translate('Full Catalogue') },
    { id: 'catalogue-my', value: TARIFF_DATASET_MY_CUSTOM, title: translate('My custom tariffs only') },
    { id: 'catalogue-os', value: TARIFF_DATASET_OS_MANAGED, title: translate('OpenSolar catalogue only') },
  ]
}

export const TARIFF_CATALOGUE_LIST_DATASET_CHOICES = [
  { id: TARIFF_DATASET_ALL, name: 'All (this org + OpenSolar)' },
  { id: TARIFF_DATASET_MY_CUSTOM, name: 'This organisation only' },
  { id: TARIFF_DATASET_OS_MANAGED, name: 'OpenSolar catalogue only' },
] as const

export function catalogueScopeToApiTariffDataset(scope: TariffSelectorCatalogueScope): string {
  return scope === TARIFF_DATASET_DEFAULT ? TARIFF_DATASET_DEFAULT : scope
}
